import { CALGARY_LABEL_EN, CALGARY_LOCATION_ID } from '@/constants/location'

/**
 * Checks if the given location is in the province of Alberta based on location
 * ID or address. If they are in a region or city in Alberta, this function
 * should return true
 *
 * @returns boolean
 */
export const isLocationInCalgary = ({
  id,
  streetAddress,
}: {
  id?: number
  streetAddress?: string | null
}): boolean => {
  const isIdInCalgary = id && id === CALGARY_LOCATION_ID
  const addressChunks = streetAddress?.split(',')
  const isAddressInCalgary = addressChunks
    ? addressChunks[addressChunks.length - 2]?.trim() === CALGARY_LABEL_EN
    : false

  return isIdInCalgary || isAddressInCalgary
}
